// @flow

import React, { useRef, useState, useEffect } from "react";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";
import classNames from "classnames";

const excludedProps = ["id", "type", "value", "onChange", "children", "className", "errorMessage", "isError", "labelText"];

type PropsType = {
    id?: string,
    className?: string,
    disabled?: boolean,
    errorMessage?: string,
    isError?: boolean,
    onChange: any => any,
    labelText?: string,
    readOnly?: boolean,
    required?: boolean,
    style?: Object,
    value: ?string
};

const filterProps = (_props: any): any => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {})
});


const MyComponent = (props: PropsType) => {
    const {
        disabled = false,
        isError = false,
        required = false,
        errorMessage = "Error",
        readOnly = false,
        onChange,
        value,
        id,
        labelText,
        className
    } = props;

    const elementProps = filterProps(props);
    const _id = id || uuid();
    const inputEl = useRef(null);
    const [cursor, setCursor] = useState({ start: null, end: null });
    useEffect(() => {
        if (typeof cursor.start === "number") {
            inputEl.current.selectionStart = cursor.start;
        }
        if (typeof cursor.end === "number") {
            inputEl.current.selectionEnd = cursor.end;
        }
    });
    return (
        <label
            className={ classNames("text-box",
                {
                    "is-required": required,
                    "is-error": isError,
                    "is-disabled": disabled,
                    "is-read-only": readOnly,
                    [className]: Boolean(className)
                }
            ) }
            htmlFor={ _id }
        >
            <span className="text-box--label-text">{ labelText }</span>
            <span className={ "text-box--error-message" }>{ errorMessage }</span>
            <input
                { ...elementProps }
                ref={ inputEl }
                onChange={ (e) => {
                    setCursor({ start: e.target.selectionStart, end: e.target.selectionEnd });
                    const val = e.target.value;
                    onChange(val);
                } }
                id={ _id }
                value={ value || "" }
                type={ "text" }
            />
        </label>
    );
};

export const TextBox = withValidation(MyComponent);